import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'
import store from '@/store'

export async function sendVerificationEmail(language = null) {
    const user = firebase.auth().currentUser
    if (!user) return

    if (store.state.config?.emailConfirmationViaFunctions) {
        try {
            const fn = firebase.functions().httpsCallable('httpAuth-sendVerificationEmail')
            await fn({ language: language || undefined, app: 'builder' })
            return
        } catch (err) {
            console.log('sendVerificationEmail via functions failed, fallback to native', err)
        }
    }

    await user.sendEmailVerification()
}
